const pageType = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType
if(typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/account/login")) {
    const loop = setInterval(() => {
      const createBtn = document.querySelector('[data-wau-modal-target="create-customer"]');
      if (createBtn) {
          const modalCreate = document.querySelector('#modal-create-customer');
          if(modalCreate) {
            modalCreate.style.display = "none";
          }
          createBtn.addEventListener("click", (event) => {
              event.preventDefault(); 
              window.location.href = "/pages/wholesale-signup-form";
          });
          clearInterval(loop);
      }
    }, 200);

    setTimeout(() => {
        clearInterval(loop);
    }, 10000);
  }
}

document.addEventListener("click", (e) => {
   const bssCheckoutBtn = document.querySelector(".btn.btn-checkout")
   if (BSS_B2B && e.target.name === "checkout" && bssCheckoutBtn) {
     e.preventDefault();
     e.stopImmediatePropagation();
     bssCheckoutBtn.click();
   }
});
